import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import RightMenu from "../RightMenu";
import CalendarButton from "../CalendarButton";
import Letters from "../../Elements/Letters/Letters";
import Dropdown from "../Dropdown";
import RightIconMenu from "../RightIconMenu";

export default class View_type_6 extends Component {
  constructor(props) {
    super(props);

    var data = {
      artists: [],
      letters: [],
      prev_dropdown: [],
      left_filter: [],
      title: "",
      ...props.data
    };
    this.state = {
      data: data,
      prevDropdown: data.prev_dropdown,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

      // prevDropdown: ['1']
    };
    //console.log("View_type_6:", this.state);
  }

  createMarkup(item) {
    return { __html: item };
  }

  render() {
    var artists = this.state.data.artists;

    var arrayArtists = [];

    Object.keys(this.state.data.artists).map(function(key, value) {
      arrayArtists.push(artists[key]);
      return 0;
    });
		//console.log('test Poprzednie',this.state.data.prev_dropdown.current);
    return (
      <div className="vt6">
        <div className="vt6 right col-xs-12 col-sm-12 ArtistsLettersMobile">
          {this.state.data.prev_dropdown.current&&this.state.data.prev_dropdown.current && (
            <div className="vt6 artists-pageTitle">
              Poprzednie Edycje {this.state.data.prev_dropdown.current}{" "}
            </div>
          )}
          <div className="vt6 artists-pageTitle">{this.state.data.title}</div>
          {this.state.data.letters.length ? (
            <Letters data={this.state.data.letters} />
          ) : null}
        </div>

        {/* <Dropdown data={this.state.prevDropdown} /> */}
        <div className="vt6 left left--tablet col-xs-12 col-sm-12 col-md-9 col-lg-9">
          <div className="vt6 artists-pageTitle artists-TitleDesktop col-md-12">
            {this.state.data.title}
          </div>
          <div className="vt6 col-md-12 vt6 fillter-row">
            {this.state.data.left_filter &&
              this.state.data.left_filter.options && (
                <div className="vt6 dropDown__wrapper">
                  <Dropdown data={this.state.data.left_filter} />
                </div>
              )}
            <div className="vt6 artists_list">
            {Object.keys(artists).map(function(key, value) {
              return (
                <ul className={key + " letters_list"} key={value}>
                  <div className="vt6 arists-alphabetwrapper" key={value}>
                    <span className="vt6 arists-alphabetblock">{key}</span>
                    <span className="vt6 line" />
                    <span className="vt6 clearBoth" />
                  </div>

                  {arrayArtists[value].map(function(object, i) {
                    return (
                      <li className="vt6 artistsAlphaberDescription" key={object.id}>
                        {object.url.length > 0 ? (
                          <a className="vt6 artistsAlphaberDescriptionItem" href={object.url}>
                            {object.name}
                          </a>
                          ) : (
                              <span>
                                {object.name}
                              </span>
                          )
                        }
                        {object.right ? 
                          (object.right.map(function(right, right_index) {
                            var date = right.date;
                            var url = right.url;
                            return (
                              <div className="artist-day-box">
                                <a href={url}>
                                  {date}
                                </a>
                              </div>
                            )
                          }))
                        : null}
                      </li>);
                  })}
                </ul>
              );
            })}
            </div>
          </div>
        </div>
        <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
          {this.state.data.right_menu &&
            this.state.data.prev_dropdown.current && (
              <div className="vt2 RightMenu">
                <Dropdown giveMeClassName={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length>5 ? 'festiwal--dropdown' : 'normal'}`} className='prevDropdown__dates'
                  border={true}
                  data={this.state.prevDropdown} />
								<RightMenu data={this.state.data.right_menu}/>
              </div>
            )}
						{this.state.rightIconMenu &&
							<RightIconMenu data={this.state.rightIconMenu}/>
						}
          <div className="vt6 right col-xs-3 col-sm-3 col-md-12 col-lg-12 ArtistsLettersDesktop">
            {/* {this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null} */}
            {this.state.data.letters.length ? (
              <Letters data={this.state.data.letters} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_6/index.js